import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, isLoading, user } = useAuth0();

  if (isLoading) {
    return (
      <div className="loading">
        <p>Loading authentication...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
        <h2>Authentication Required</h2>
        <p style={{ marginBottom: '30px', color: '#666' }}>
          Please log in to access this feature.
        </p>
      </div>
    );
  }

  // Check role if required
  if (requiredRole) {
    const userRoles = user?.['https://dataapp.mallikoviresearchgroup.no/roles'] || [];
    if (!userRoles.includes(requiredRole)) {
      return (
        <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
          <h2>Access Denied</h2>
          <p style={{ color: '#d32f2f' }}>
            You don't have permission to access this feature.
          </p>
          <p style={{ marginTop: '20px', color: '#666' }}>
            Required role: <strong>{requiredRole}</strong>
          </p>
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute;
